import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appearsIn"];
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import debounce from 'react-utils/debounce';
import { useEffect, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const SearchFilter = _ref => {
  let {
      appearsIn
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [[searchParam], setSearchParam] = useSearchParam(FILTER_TYPES.SEARCH);
  const [search, setSearch] = useState(searchParam);
  const debouncedSearch = useMemo(() => debounce(debouncedSearchValue => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: 'filter-selected',
      value: debouncedSearchValue,
      isDropdown: false,
      key: 'search-filter',
      appearsIn
    });
    setSearchParam(debouncedSearchValue);
  }, 400), [appearsIn, setSearchParam]);
  const handleSearchChange = e => {
    setSearch(e.target.value);
    debouncedSearch(e.target.value);
  };
  useEffect(() => {
    setSearch(searchParam);
  }, [searchParam]);
  return /*#__PURE__*/_jsx(SearchInput, Object.assign({
    onChange: handleSearchChange,
    value: search
  }, props));
};